enum UserStatusReasonEnum {
  DEATH = 'death',
  EXPIRED_BY_SYSTEM = 'expired_by_system',
  INCOMPLETE_REGISTRATION = 'incomplete_registration',
  OTHER = 'other',
  WITHDRAWAL = 'withdrawal',
}

export default UserStatusReasonEnum;
